import { Component, OnDestroy, OnInit, forwardRef, Inject, Input, OnChanges, SimpleChanges, input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
import { isNotNullOrUndefinedOrEmpty, isNullOrUndefined } from '@infrastructure/objectUtils';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'beneficiary-identification',
  templateUrl: './beneficiary-identification.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class BeneficiaryIdentificationComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy, OnChanges {

  @Input("dropdowns")
  public dropdowns: models.WorkflowDropdownsVM;

  @Input("cardData")
  public cardData: models.BeneficiaryIdentificationVM = {} as models.BeneficiaryIdentificationVM;

  @Input("personTypologyCode")
  public personTypologyCode: string;
  //@Input() benefitChoosen: BenefitChoosen;

  @Input("beneficiaryID")
  public beneficiaryID: number;

  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;



  @Input()  public nationalities: models.DimensionVM[];
  @Input()  public genders: models.DimensionVM[];
  public maritalStatus: models.Options[];
  public maritalStatusSingle: models.Options[];
  @Input()  public documentTypes: models.DimensionVM[];
  @Input()  public yesNo: models.DimensionVM[];
  
  public preFilledProperties: PreFilledProperty[] = [];

  public personTypesValues = DropdownsValues.dropDownPersonType;

  
  constructor(
    @Inject(BeneficiaryListTableEditComponent) public parent: Component,
    private modalService: ModalService,
    private beneficiaryValuesService: BeneficiaryValuesService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData = (<any>parent)._cardData;
  }
    

  public taxServiceValues = [];
  public taxServiceFound;
  public financialServiceDescription: string;


  ngOnInit(): void {



    this.maritalStatus= this.dropdowns.options
      .filter(el => el.dropdown === "dropListMaritalStatus");


    // Não me lembro do porquê desta diferenciação, não tem muita lógica, ver com o pessoal do BE
    //this.maritalStatusSingle = this.dropdowns.options
    //  .filter(el => el.dropdown === "dropListMaritalStatus" && el.description === "UF");
    this.maritalStatusSingle = this.maritalStatus;

    this.taxServiceValues = this.dropdowns.options
      .filter(el => el.dropdown === "DropdownTaxOffice");
  }




  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cardData?.isFirstChange()) {
      const fieldArray = [
        "beneficiaryName",
        "dateOfBirth",
        "hasNacPT",
        "hasNIFPT",
        "NIF",
        "financialService",
        "identificationNumberFirst",
        "identificationNumberLast",
        "gender",
        "NISS",
        "identificationDocumentType",
        "finantialServiceFirst",
        "civilState",
        "nationality"
      ];

      //Assumimos que o campo hasNIFPT é sempre verdadeiro
      this.cardData.hasNIFPT = true;
      //Corrigir a NAcionalidade, pois se tem nacionalide portuguesa é para atualizar o campo
      if ((this.cardData.hasNacPT?.toString() == "true") && (this.cardData.nationality == null || this.cardData.nationality == undefined)) {
        this.cardData.nationality = "PT";
      }
      //if (isNotNullOrUndefinedOrEmpty(this.cardData.civilState)) {
      //  this.cardData.civilStateDeathDate = null;
      //}
      this.preFilledProperties =
        this.beneficiaryValuesService
          .getPreFilledProperties(this.beneficiaryID, this.cardData, fieldArray);
    }
    
  }

  ngOnDestroy(): void {
  }

  personTypelogyCodeChanged() {
    
  }

  public hasCivilState(): boolean {
    if (this.cardData.civilState == undefined || this.cardData.civilState == null) {
      return false;
    }
    return true;
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  public isStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return result;
  }

  public countryChanged(): void { }

  //isVersion2() {
  //  let result = false;
  //  if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
  //    result = true;
  //  }
  //  return result;
  //}

  onTaxServiceCodeChanged() {
    this.taxServiceFound = false;
    if (this.cardData.financialService?.toString().length >= 0) {
      let inputTaxFound = this.taxServiceValues.
        find(el => el.value == this.cardData.financialService);
      if (inputTaxFound != null && inputTaxFound != undefined) {
        this.taxServiceFound = true;
        this.cardData.financialServiceLast = inputTaxFound.description;
      }
    } 
  }

}
